import state from './moduloPersonalizacionState';
import mutations from './moduloPersonalizacionMutations';
import actions from './moduloPersonalizacionActions';
import * as getters from './moduloPersonalizacionGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
